<template>
    <div class="not-found-container">
      <div class="not-found-content">
        <div class="error-code">
          <span class="digit">4</span>
          <div class="dumbbell-icon">
            <FaIcon icon="dumbbell" />
          </div>
          <span class="digit">4</span>
        </div>
        
        <h1>Seite nicht gefunden</h1>
        
        <p class="motivational-text">
          Keine Sorge! Wie beim Training - manchmal muss man einen Umweg gehen, 
          um ans Ziel zu kommen.
        </p>
        
        <div class="action-buttons">
          <router-link to="/" class="btn btn-primary me-3">
            <FaIcon icon="home" class="me-2" />Zurück zur Startseite
          </router-link>
        </div>
      </div>
    </div>
</template>
  
<script>
  export default {
    name: 'NotFoundPage',
  }
  </script>
  
  <style scoped>
  .not-found-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background: linear-gradient(135deg, #f6f8f9 0%, #e5ebee 100%);
    text-align: center;
    padding: 20px;
  }
  
  .not-found-content {
    background-color: white;
    border-radius: 15px;
    box-shadow: 0 10px 30px rgba(0,0,0,0.1);
    padding: 40px;
    max-width: 600px;
    width: 100%;
  }
  
  .error-code {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
  }
  
  .digit {
    font-size: 120px;
    font-weight: bold;
    color: #42b983;
    line-height: 1;
  }
  
  .dumbbell-icon {
    font-size: 100px;
    color: #ff6b6b;
    margin: 0 20px;
    transform: rotate(-20deg);
  }
  
  h1 {
    color: #333;
    margin-bottom: 20px;
    font-size: 2.5rem;
  }
  
  .motivational-text {
    color: #666;
    font-size: 1.1rem;
    margin-bottom: 30px;
    line-height: 1.6;
  }
  
  .action-buttons {
    display: flex;
    justify-content: center;
    gap: 15px;
  }
  
  .btn {
    display: inline-flex;
    align-items: center;
    padding: 12px 20px;
    font-weight: bold;
    border-radius: 8px;
    transition: all 0.3s ease;
  }
  
  .btn-primary {
    background-color: #42b983;
    border-color: #42b983;
  }
  
  .btn-outline-success {
    border-color: #42b983;
    color: #42b983;
  }
  
  .btn:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 17px rgba(0, 0, 0, 0.15);
  }
  
  @media (max-width: 768px) {
    .error-code {
      flex-direction: column;
    }
    
    .digit {
      font-size: 80px;
    }
    
    .dumbbell-icon {
      font-size: 70px;
      margin: 20px 0;
    }
    
    .action-buttons {
      flex-direction: column;
    }
  }
</style>